import { Component } from '@angular/core';

@Component({
  selector: 'app-information-sidebar-feedback-requests',
  templateUrl: './information-sidebar-feedback-requests.component.html',
  styleUrls: ['./information-sidebar-feedback-requests.component.scss']
})
export class InformationSidebarFeedbackRequestsComponent {
}
